<template>
  <div>
    <div class="store-coustomer">
      <el-table
        v-loading="tableLoading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column prop="createTime" label="微信头像"  align="center">
          <template slot-scope="scope">
            <img :src="scope.row.avatarUrl " alt />
          </template>
        </el-table-column>
        <el-table-column prop="nickName" align="center" label="微信名称"></el-table-column>
        <el-table-column prop="userName" label="姓名" align="center"></el-table-column>
        <el-table-column prop="userPhone" label="手机号" align="center"></el-table-column>
        <el-table-column prop="shopName" label="所属门店" align="center"></el-table-column>
        <el-table-column prop="createTime" label="时间" align="center"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { getShopAndUser } from '@/api/stores';

export default {
  data() {
    return {
      tableData: [],
      tableLoading: false,
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 1,
    };
  },
  mounted() {
    this.getShopAndUser();
  },
  methods: {
    // 获取店员详情
    getShopAndUser() {
      this.tableLoading = true;
      const { id } = this.$route.query;
      getShopAndUser(id).then((res) => {
        if (res.success) {
          const { users, shopName } = res.data;
          if (users && Array.isArray(users)) {
            this.tableData = users.map((item) => ({
              ...item,
              shopName,
            }));
            this.tableLoading = false;
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
img
  width 50px
  height 50px
</style>
